import { ICardsinstagramItem, IpaginatedCardsinstagram } from '../models'

export enum CardsinstagramActionTypes {
  SEARCH_CARDSINSTAGRAM = 'cardsinstagram/search',
  SEARCHING_CARDSINSTAGRAM = 'cardsinstagram/searching',
  FOUND_CARDSINSTAGRAM = 'cardsinstagram/found',
  SEARCHING_CARDSINSTAGRAM_FAILED = 'cardsinstagram/searching_failed',

  LOAD_CARDSINSTAGRAM = 'cardsinstagram/load',
  LOADING_CARDSINSTAGRAM = 'cardsinstagram/loading',
  LOADED_CARDSINSTAGRAM = 'cardsinstagram/loaded',
  LOADING_CARDSINSTAGRAM_FAILED = 'cardsinstagram/loading_failed',

  ADD_CARDSINSTAGRAM = 'cardsinstagram/add',
  ADDING_CARDSINSTAGRAM = 'cardsinstagram/adding',
  ADDED_CARDSINSTAGRAM = 'cardsinstagram/added',
  ADDING_CARDSINSTAGRAM_FAILED = 'cardsinstagram/adding_failed',

  REMOVE_CARDINSTAGRAM = 'cardsinstagram/remove',
  REMOVING_CARDINSTAGRAM = 'cardsinstagram/removing',
  REMOVED_CARDINSTAGRAM = 'cardsinstagram/removed',
  REMOVING_CARDINSTAGRAM_FAILED = 'cardsinstagram/removing_failed',

  SOFT_REMOVE_CARDSINSTAGRAM = 'cardsinstagram/soft_remove',
  SOFT_REMOVING_CARDSINSTAGRAM = 'cardsinstagram/soft_removing',
  SOFT_REMOVED_CARDSINSTAGRAM = 'cardsinstagram/soft_removed',
  SOFT_REMOVING_CARDSINSTAGRAM_FAILED = 'cardsinstagram/soft_removing_failed',

  EDIT_CARDSINSTAGRAM = 'cardsinstagram/edit',
  EDITING_CARDSINSTAGRAM = 'cardsinstagram/editing',
  EDITED_CARDSINSTAGRAM = 'cardsinstagram/edited',
  EDITING_CARDSINSTAGRAM_FAILED = 'cardsinstagram/editing_failed',

  VIEW_CARDSINSTAGRAM = 'cardsinstagram/view',
  VIEWING_CARDSINSTAGRAM = 'cardsinstagram/viewing',
  VIEWED_CARDSINSTAGRAM = 'cardsinstagram/viewed',
  VIEWING_CARDSINSTAGRAM_FAILED = 'cardsinstagram/viewing_failed',
}

export function searchCardsinstagram(searchOptions: TSearchOptions | string, keep?: boolean): ISearchCardsinstagramAction {
  return {
    type: CardsinstagramActionTypes.SEARCH_CARDSINSTAGRAM,
    searchOptions: typeof searchOptions === 'string' ? { searchString: searchOptions } : searchOptions,
    keep: keep,
  }
}

export function searchingCardsinstagram(): ISearchingCardsinstagramAction {
  return {
    type: CardsinstagramActionTypes.SEARCHING_CARDSINSTAGRAM,
  }
}

export function foundCardsinstagram(cardsinstagram: IpaginatedCardsinstagram, keep?: boolean): IFoundCardsinstagramAction {
  return {
    type: CardsinstagramActionTypes.FOUND_CARDSINSTAGRAM,
    keep: keep,
    payload: {
      cardsinstagram,
    },
  }
}

export function searchingCardsinstagramFailed(): ISearchingCardsinstagramFailedAction {
  return {
    type: CardsinstagramActionTypes.SEARCHING_CARDSINSTAGRAM_FAILED,
  }
}

export function loadCardsinstagram(loadOptions: TSearchOptions): ILoadCardsinstagramAction {
  return {
    type: CardsinstagramActionTypes.LOAD_CARDSINSTAGRAM,
    loadOptions: loadOptions,
  }
}

export function loadingCardsinstagram(): ILoadingCardsinstagramAction {
  return {
    type: CardsinstagramActionTypes.LOADING_CARDSINSTAGRAM,
  }
}

export function loadedCardsinstagram(cardsinstagram: IpaginatedCardsinstagram): ILoadedCardsinstagramAction {
  return {
    type: CardsinstagramActionTypes.LOADED_CARDSINSTAGRAM,
    payload: {
      cardsinstagram,
    },
  }
}

export function loadingCardsinstagramFailed(): ILoadingCardsinstagramFailedAction {
  return {
    type: CardsinstagramActionTypes.LOADING_CARDSINSTAGRAM_FAILED,
  }
}

export function addCardsinstagram(cardinstagram: ICardsinstagramItem): IAddCardsinstagramAction {
  return {
    type: CardsinstagramActionTypes.ADD_CARDSINSTAGRAM,
    payload: cardinstagram,
  }
}

export function addingCardsinstagram(): IAddingCardsinstagramAction {
  return {
    type: CardsinstagramActionTypes.ADDING_CARDSINSTAGRAM,
  }
}

export function addedCardsinstagram(cardsinstagram: IpaginatedCardsinstagram): IAddedCardsinstagramAction {
  return {
    type: CardsinstagramActionTypes.ADDED_CARDSINSTAGRAM,
    payload: {
      cardsinstagram,
    },
  }
}

export function addingCardsinstagramFailed(errData: {
  data: { message: string; field?: string }
  status: number
}): IAddingCardsinstagramFailedAction {
  return {
    type: CardsinstagramActionTypes.ADDING_CARDSINSTAGRAM_FAILED,
    message: errData.data.message,
    status: errData.status,
    field: errData.data.field,
  }
}

export function removeCardinstagram(cardinstagram: ICardsinstagramItem): IRemoveCardinstagramAction {
  return {
    type: CardsinstagramActionTypes.REMOVE_CARDINSTAGRAM,
    payload: cardinstagram,
  }
}

export function removingCardinstagram(): IRemovingCardinstagramAction {
  return {
    type: CardsinstagramActionTypes.REMOVING_CARDINSTAGRAM,
  }
}

export function removedCardinstagram(): IRemovedCardinstagramAction {
  return {
    type: CardsinstagramActionTypes.REMOVED_CARDINSTAGRAM,
  }
}

export function removingCardinstagramFailed(): IRemovingCardinstagramFailedAction {
  return {
    type: CardsinstagramActionTypes.REMOVING_CARDINSTAGRAM_FAILED,
  }
}

export function softRemoveCardsinstagram(cardinstagram: ICardsinstagramItem): ISoftRemoveCardsinstagramAction {
  return {
    type: CardsinstagramActionTypes.SOFT_REMOVE_CARDSINSTAGRAM,
    payload: cardinstagram,
  }
}

export function softRemovingCardsinstagram(): ISoftRemovingCardsinstagramAction {
  return {
    type: CardsinstagramActionTypes.SOFT_REMOVING_CARDSINSTAGRAM,
  }
}

export function softRemovedCardsinstagram(cardinstagram: ICardsinstagramItem): ISoftRemovedCardsinstagramAction {
  return {
    type: CardsinstagramActionTypes.SOFT_REMOVED_CARDSINSTAGRAM,
    payload: cardinstagram,
  }
}

export function softRemovingCardsinstagramFailed(errData: {
  data: { message: string; field?: string }
  status: number
}): ISoftRemovingCardsinstagramFailedAction {
  return {
    type: CardsinstagramActionTypes.SOFT_REMOVING_CARDSINSTAGRAM_FAILED,
    message: errData.data.message,
    status: errData.status,
    field: errData.data.field,
  }
}

export function editCardsinstagram(cardinstagram: ICardsinstagramItem): IEditCardsinstagramAction {
  return {
    type: CardsinstagramActionTypes.EDIT_CARDSINSTAGRAM,
    payload: cardinstagram,
  }
}

export function editingCardsinstagram(): IEditingCardsinstagramAction {
  return {
    type: CardsinstagramActionTypes.EDITING_CARDSINSTAGRAM,
  }
}

export function editedCardsinstagram(cardsinstagram: ICardsinstagramItem): IEditedCardsinstagramAction {
  return {
    type: CardsinstagramActionTypes.EDITED_CARDSINSTAGRAM,
    payload: cardsinstagram,
  }
}

export function editingCardsinstagramFailed(errData: {
  data: { message: string; field?: string }
  status: number
}): IEditingCardsinstagramFailedAction {
  return {
    type: CardsinstagramActionTypes.EDITING_CARDSINSTAGRAM_FAILED,
    message: errData.data.message,
    status: errData.status,
    field: errData.data.field,
  }
}

export function viewCardsinstagram(cardinstagram: ICardsinstagramItem): IViewCardsinstagramAction {
  return {
    type: CardsinstagramActionTypes.VIEW_CARDSINSTAGRAM,
    payload: cardinstagram,
  }
}

export function viewingCardsinstagram(): IViewingCardsinstagramAction {
  return {
    type: CardsinstagramActionTypes.VIEWING_CARDSINSTAGRAM,
  }
}

export function viewedCardsinstagram(cardsinstagram: ICardsinstagramItem): IViewedCardsinstagramAction {
  return {
    type: CardsinstagramActionTypes.VIEWED_CARDSINSTAGRAM,
    payload: cardsinstagram,
  }
}

export function viewingCardsinstagramFailed(): IViewingCardsinstagramFailedAction {
  return {
    type: CardsinstagramActionTypes.VIEWING_CARDSINSTAGRAM_FAILED,
  }
}

type TSearchOptions = {
  searchString?: string
  searchField?: string
  page?: number
  limit?: number
  populate?: boolean
  sort?: {
    field: string
    method?: 'asc' | 'desc'
  }
  filters?: { field: string; value: string }[]
}

export interface ISearchCardsinstagramAction {
  type: CardsinstagramActionTypes.SEARCH_CARDSINSTAGRAM
  searchOptions: TSearchOptions
  keep?: boolean
}

export interface ISearchingCardsinstagramAction {
  type: CardsinstagramActionTypes.SEARCHING_CARDSINSTAGRAM
}

export interface IFoundCardsinstagramAction {
  type: CardsinstagramActionTypes.FOUND_CARDSINSTAGRAM
  keep?: boolean
  payload: {
    cardsinstagram: IpaginatedCardsinstagram
  }
}

export interface ISearchingCardsinstagramFailedAction {
  type: CardsinstagramActionTypes.SEARCHING_CARDSINSTAGRAM_FAILED
}

export interface ILoadCardsinstagramAction {
  type: CardsinstagramActionTypes.LOAD_CARDSINSTAGRAM
  loadOptions: TSearchOptions
}

export interface ILoadingCardsinstagramAction {
  type: CardsinstagramActionTypes.LOADING_CARDSINSTAGRAM
}

export interface ILoadedCardsinstagramAction {
  type: CardsinstagramActionTypes.LOADED_CARDSINSTAGRAM
  payload: {
    cardsinstagram: IpaginatedCardsinstagram
  }
}

export interface ILoadingCardsinstagramFailedAction {
  type: CardsinstagramActionTypes.LOADING_CARDSINSTAGRAM_FAILED
}

export interface IAddCardsinstagramAction {
  type: CardsinstagramActionTypes.ADD_CARDSINSTAGRAM
  payload: ICardsinstagramItem
}

export interface IAddingCardsinstagramAction {
  type: CardsinstagramActionTypes.ADDING_CARDSINSTAGRAM
}

export interface IAddedCardsinstagramAction {
  type: CardsinstagramActionTypes.ADDED_CARDSINSTAGRAM
  payload: {
    cardsinstagram: IpaginatedCardsinstagram
  }
}

export interface IAddingCardsinstagramFailedAction {
  type: CardsinstagramActionTypes.ADDING_CARDSINSTAGRAM_FAILED
  message: string
  status: number
  field?: string
}

export interface IRemoveCardinstagramAction {
  type: CardsinstagramActionTypes.REMOVE_CARDINSTAGRAM
  payload: ICardsinstagramItem
}

export interface IRemovingCardinstagramAction {
  type: CardsinstagramActionTypes.REMOVING_CARDINSTAGRAM
}

export interface IRemovedCardinstagramAction {
  type: CardsinstagramActionTypes.REMOVED_CARDINSTAGRAM
}

export interface IRemovingCardinstagramFailedAction {
  type: CardsinstagramActionTypes.REMOVING_CARDINSTAGRAM_FAILED
}

export interface ISoftRemoveCardsinstagramAction {
  type: CardsinstagramActionTypes.SOFT_REMOVE_CARDSINSTAGRAM
  payload: ICardsinstagramItem
}

export interface ISoftRemovingCardsinstagramAction {
  type: CardsinstagramActionTypes.SOFT_REMOVING_CARDSINSTAGRAM
}

export interface ISoftRemovedCardsinstagramAction {
  type: CardsinstagramActionTypes.SOFT_REMOVED_CARDSINSTAGRAM
  payload: ICardsinstagramItem
}

export interface ISoftRemovingCardsinstagramFailedAction {
  type: CardsinstagramActionTypes.SOFT_REMOVING_CARDSINSTAGRAM_FAILED
  message: string
  status: number
  field?: string
}

export interface IEditCardsinstagramAction {
  type: CardsinstagramActionTypes.EDIT_CARDSINSTAGRAM
  payload: ICardsinstagramItem
}

export interface IEditingCardsinstagramAction {
  type: CardsinstagramActionTypes.EDITING_CARDSINSTAGRAM
}

export interface IEditedCardsinstagramAction {
  type: CardsinstagramActionTypes.EDITED_CARDSINSTAGRAM
  payload: ICardsinstagramItem
}

export interface IEditingCardsinstagramFailedAction {
  type: CardsinstagramActionTypes.EDITING_CARDSINSTAGRAM_FAILED
  message: string
  status: number
  field?: string
}

export interface IViewCardsinstagramAction {
  type: CardsinstagramActionTypes.VIEW_CARDSINSTAGRAM
  payload: ICardsinstagramItem
}

export interface IViewingCardsinstagramAction {
  type: CardsinstagramActionTypes.VIEWING_CARDSINSTAGRAM
}

export interface IViewedCardsinstagramAction {
  type: CardsinstagramActionTypes.VIEWED_CARDSINSTAGRAM
  payload: ICardsinstagramItem
}

export interface IViewingCardsinstagramFailedAction {
  type: CardsinstagramActionTypes.VIEWING_CARDSINSTAGRAM_FAILED
}

export type CardsinstagramAction =
  | ISearchCardsinstagramAction
  | ISearchingCardsinstagramAction
  | IFoundCardsinstagramAction
  | ISearchingCardsinstagramFailedAction
  | ILoadCardsinstagramAction
  | ILoadingCardsinstagramAction
  | ILoadedCardsinstagramAction
  | ILoadingCardsinstagramFailedAction
  | IAddCardsinstagramAction
  | IAddingCardsinstagramAction
  | IAddedCardsinstagramAction
  | IAddingCardsinstagramFailedAction
  | IRemoveCardinstagramAction
  | IRemovingCardinstagramAction
  | IRemovedCardinstagramAction
  | IRemovingCardinstagramFailedAction
  | ISoftRemoveCardsinstagramAction
  | ISoftRemovingCardsinstagramAction
  | ISoftRemovedCardsinstagramAction
  | ISoftRemovingCardsinstagramFailedAction
  | IEditCardsinstagramAction
  | IEditingCardsinstagramAction
  | IEditedCardsinstagramAction
  | IEditingCardsinstagramFailedAction
  | IViewCardsinstagramAction
  | IViewingCardsinstagramAction
  | IViewedCardsinstagramAction
  | IViewingCardsinstagramFailedAction
